/**
 * What fills the content area while a route chunk is in flight.
 *
 * It was a `min-h-dvh` centred spinner, rendered INSIDE <main> — so it opened a
 * full viewport of empty page below the header and put the only mark on screen
 * halfway down it. On a phone that reads as a blank page for as long as the
 * chunk takes, which on the cold load is exactly when the wait is longest.
 *
 * The shape mirrors PageHeader + Card at the same metrics, so nothing jumps
 * when the real screen replaces it.
 */
export function RouteFallback() {
  return (
    <div role="status" aria-busy="true" className="animate-pulse">
      {/* The screen reader gets a sentence; the eye gets the shape. Announcing
          every bar would be noise. */}
      <span className="sr-only">Sayfa yükleniyor…</span>

      <div className="mb-5 sm:mb-6" aria-hidden="true">
        <div className="bg-surface-muted h-7 w-48 rounded-md sm:h-8 sm:w-64" />
        <div className="bg-surface-muted mt-2 h-4 w-full max-w-sm rounded" />
      </div>

      <div
        className="border-border bg-surface overflow-hidden rounded-xl border"
        aria-hidden="true"
      >
        <div className="border-border bg-surface-muted/60 h-11 border-b" />
        {[0, 1, 2, 3, 4].map((row) => (
          <div key={row} className="border-border flex items-center gap-4 border-b px-4 py-3.5">
            <div className="bg-surface-muted h-4 flex-1 rounded" />
            <div className="bg-surface-muted hidden h-4 w-32 rounded sm:block" />
            <div className="bg-surface-muted h-4 w-16 rounded" />
          </div>
        ))}
      </div>
    </div>
  );
}
